<template>
    <app-modal :modal-id="modalId"
        :preloader="preloader"
        modal-alignment="center"
        modal-size="large"
        modal-scroll="false"
        :modal-scroll="false"
        @submit="submit"
        @close-modal="closeModal"
        class="add_notification">
        <template slot="header">
            <div>
                <h5 class="modal-title">{{ (this.selectedUrl ? $t('edit') : $t('add'))+' '+ $t('notification') }}</h5>
            </div>
            <button type="button" class="close outline-none" data-dismiss="modal" aria-label="Close">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
            <form class="mb-0" ref="form"
                  :class="{'loading-opacity': preloader}"
                  :data-url='selectedUrl ? selectedUrl : `manage-notifications/save`'>
                <div class="form-group row align-items-center">
                    <label for="title" class="col-sm-4">
                        {{ $t('title') }}*
                    </label>
                    <app-input id="title"
                        class="col-sm-8"
                        type="text"
                        v-model="formData.name"
                        :placeholder="$t('enter_title')"
                        :required="true"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="teams" class="col-sm-4">
                        {{ $t('teams') }}
                    </label>
                    <app-input
                        class="col-sm-8"
                        type="multi-search-select"
                        :loaded-per-time="10"
                        v-model="formData.teams"
                        fetch-url="/teams/"
                        :placeholder="$t('search_teams')"
                        list-value-field="name"
                        :required="false"
                    />
                </div>
                <div class="form-group row align-items-center">
                    <label for="leagues" class="col-sm-4">
                        {{ $t('leagues') }}
                    </label>
                    <app-input
                        class="col-sm-8"
                        type="multi-search-select"
                        :loaded-per-time="10"
                        v-model="formData.leagues"
                        fetch-url="/leagues/"
                        :placeholder="$t('search_leagues')"
                        list-value-field="name"
                        x-placement="bottom-start"
                        :required="false"
                    />
                </div>
                <div class="form-group row align-items-center">
                    <label for="sport" class="col-sm-4">
                        {{ $t('sport') }}
                    </label>
                    <app-input class="col-sm-8"
                        type="select"
                        :list="sportOptions"
                        v-model="formData.sport"
                        :required="false"/>     
                </div>
                <div class="form-group row align-items-center">
                    <label for="time_before_start" class="col-sm-4">
                        {{ $t('time_before_start') }}
                    </label>
                    <app-input class="col-sm-4"
                               type="select"
                               :placeholder="$t('select_time_before_start')"
                               :list="timeBeforeStartOptions"
                               v-model="formData.time_before_start_enabled"
                               :required="false"/>
                </div>
                <div class="form-group row align-items-center" v-if="formData.time_before_start_enabled == 1">
                    <div class="col-sm-4 text-center">
                    </div>
                    <app-input id="days_time_before_start"
                               class="col-sm-1"
                               style="min-width: 100px"
                               type="number"
                               v-model="formData.days_before_start"
                               :placeholder="$t('days')"
                               :required="false"/>
                    <div class="col-sm-1 text-center">
                        {{ $t('days') }}
                    </div>
                    <app-input id="hours_time_before_start"
                               class="col-sm-1"
                               style="min-width: 100px"
                               type="number"
                               v-model="formData.hours_before_start"
                               :placeholder="$t('hours')"
                               :required="false"/>
                    <div class="col-sm-1 text-center">
                        {{ $t('hours') }}
                    </div>
                    <app-input id="minutes_time_before_start"
                               class="col-sm-1"
                               style="min-width: 100px"
                               type="number"
                               v-model="formData.minutes_before_start"
                               :placeholder="$t('minutes')"
                               :required="false"/>
                    <div class="col-sm-1 text-center">
                        {{ $t('minutes') }}
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="market" class="col-sm-4">
                        {{ $t('market') }}
                    </label>
                    <app-input class="col-sm-4"
                        type="select"
                        :placeholder="$t('select_market')"
                        :list="marketOptions"
                        v-model="formData.market"
                        :required="false"
                        @change="marketChange(true)"/>
                    <app-input class="col-sm-4"
                        type="select"
                        :placeholder="$t('select_submarket')"
                        :list="subMarketOptions"
                        v-model="formData.subMarket"
                        :required="false"/>     
                </div>
                 <div class="form-group row align-items-center"  v-if="formData.subMarket != 0 || formData.send_updates == 2">
                    <label for="odds" class="col-sm-4">
                        {{ $t('odds') }}
                    </label>
                    <app-input id="min_odds"
                        class="col-sm-4"
                        type="number"
                        v-model="formData.min_odds"
                        :placeholder="$t('enter_min_odds')"
                        :required="false"/>
                    <app-input id="max_odds"
                        class="col-sm-4"
                        type="number"
                        v-model="formData.max_odds"
                        :placeholder="$t('enter_max_odds')"
                        :required="false"/>
                </div>
                <div class="form-group row align-items-center" v-if="formData.market != 0 || formData.send_updates == 2">
                    <label for="stake" class="col-sm-4">
                        {{ $t('stake') }}
                    </label>
                   <app-input id="min_stake"
                        class="col-sm-4"
                        type="number"
                        v-model="formData.min_stake"
                        :placeholder="$t('enter_min_stake')"
                        :required="false"/>
                    <app-input id="max_stake"
                        class="col-sm-4"
                        type="number"
                        v-model="formData.max_stake"
                        :placeholder="$t('enter_max_stake')"
                        :required="false"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="send_updates" class="col-sm-4">
                        {{ $t('send_updates') }}*
                    </label>
                    <div class="col-sm-8">
                        <app-input class="col-sm-8"
                                   type="radio"
                                   :list="sendUpdateOptions"
                                   v-model="formData.send_updates"/>
                    </div>
                </div>
                <div class="form-group row align-items-center"  v-if="formData.send_updates == 2">
                    <label for="odds" class="col-sm-4">
                        {{ $t('time') }}
                    </label>
                    <app-input class="col-sm-4"
                               type="select"
                               :placeholder="$t('select_time')"
                               :list="updateTimeOptions"
                               v-model="formData.update.time"
                               :required="false"/>
                    <app-input class="col-sm-4"
                               type="select"
                               :placeholder="$t('diff_mode')"
                               :list="diffModeOptions"
                               v-model="formData.diff_mode"
                               :required="false"/>
                </div>
                <div class="form-group row align-items-center"  v-if="formData.send_updates == 2">
                    <label for="odds" class="col-sm-4">
                        {{ $t('odds_change') }}
                    </label>
                    <app-input id="min_odds_change"
                               class="col-sm-2"
                               type="number"
                               v-model="formData.update.odds.min"
                               :placeholder="$t('odds_change_min')"
                               :required="false"/>
                    <div class="col-sm-2">
                        <div class="customized-checkbox checkbox-default">
                            <input type="checkbox" id="odds_min_percent" v-model="formData.update.odds.min_percent">
                            <label for="odds_min_percent">%</label>
                        </div>
                    </div>
                    <app-input id="max_odds_change"
                               class="col-sm-2"
                               type="number"
                               v-model="formData.update.odds.max"
                               :placeholder="$t('odds_change_max')"
                               :required="false"/>
                    <div class="col-sm-2">
                        <div class="customized-checkbox checkbox-default">
                            <input type="checkbox" id="odds_max_percent" v-model="formData.update.odds.max_percent">
                            <label for="odds_max_percent">%</label>
                        </div>
                    </div>
                </div>
                <div class="form-group row align-items-center" v-if="formData.send_updates == 2">
                    <label for="odds" class="col-sm-4">
                        {{ $t('stake_change') }}
                    </label>
                    <app-input id="min_stake_change"
                               class="col-sm-2"
                               type="number"
                               v-model="formData.update.stake.min"
                               :placeholder="$t('stake_change_min')"
                               :required="false"/>
                    <div class="col-sm-2">
                        <div class="customized-checkbox checkbox-default">
                            <input type="checkbox" id="stake_min_percent" v-model="formData.update.stake.min_percent">
                            <label for="stake_min_percent">%</label>
                        </div>
                    </div>
                    <app-input id="max_stake_change"
                               class="col-sm-2"
                               type="number"
                               v-model="formData.update.stake.max"
                               :placeholder="$t('stake_change_max')"
                               :required="false"/>
                    <div class="col-sm-2">
                        <div class="customized-checkbox checkbox-default">
                            <input type="checkbox" id="stake_max_percent" v-model="formData.update.stake.max_percent">
                            <label for="stake_max_percent">%</label>
                        </div>
                    </div>
                </div>
                <div class="form-group row align-items-center" v-if="formData.send_updates == 2">
                    <label for="odds" class="col-sm-4">
                        {{ $t('notifications_limit') }}
                    </label>
                    <app-input id="limit_amount"
                               class="col-sm-2"
                               type="number"
                               v-model="formData.update.limit.amount"
                               :placeholder="$t('amount')"
                               :required="false"/>
                    <div class="col-sm-2 text-center">
                        {{ $t('per') }}
                    </div>
                    <app-input id="limit_time"
                               class="col-sm-2"
                               type="number"
                               v-model="formData.update.limit.time"
                               :placeholder="$t('minutes')"
                               :required="false"/>
                    <div class="col-sm-2 text-left">
                        {{ $t('minutes') }}
                    </div>
                </div>
                <div class="form-group row align-items-center mb-0" v-if="formData.send_updates == 2">
                    <label for="notification_data" class="col-sm-4">
                        {{ $t('latest_changes_data') }}*
                    </label>
                    <app-input class="col-sm-8"
                           type="checkbox"
                           :list="updateOptions"
                           v-model="formData.update_data"/>
                </div>
                <div class="form-group row align-items-center mb-0" v-if="formData.send_updates == 2">
                    <label for="status" class="col-sm-4">
                        {{ $t('update_triggers') }}*
                    </label>
                    <app-input class="col-sm-8"
                               type="checkbox"
                               :list="updateOptions"
                               v-model="formData.update_events"/>
                </div>
                <div class="form-group row align-items-center mb-0">
                    <label for="status" class="col-sm-4">
                        {{ $t('status') }}*
                    </label>
                    <app-input class="col-sm-8"
                        type="radio"
                        :list="statusOptions"
                        v-model="formData.enabled"/>
                </div>
                <div class="text-center mt-1" v-if="formData.enabled === 1 && formData.send_updates > 0">
                    {{ $t('opening_odds_and_updates_will_be_sent_unless_updates_only_is_selected') }}
                </div>
            </form>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click="closeModal">
                {{ $t('close') }}
            </button>
            <button type="submit" class="btn btn-primary" @click="submit">{{ $t('save') }}</button>
        </template>
    </app-modal>
</template>

<script>
import {FormMixin} from "../../../../../core/mixins/form/FormMixin";
import * as actions from "../../../../Config/ApiUrl";

export default {
    name: "NotificationsAddEditModal",
    mixins: [FormMixin],
    props: {
        selectedId: {},
        modalId: {
            type: String,
            default: 'notifications-view-add-edit-Modal'
        }
    },
    data() {
        return {
            preloader: false,
            formData: {
                enabled: 1,
                send_updates: 0,
                sport: 'all',
                market: 0,
                subMarket: 0,
                diff_mode: 'diff',
                update: {
                    time: 0,
                    odds: {
                        min: '',
                        max: '',
                        min_percent: false,
                        max_percent: false
                    },
                    stake: {
                        min: '',
                        max: '',
                        min_percent: false,
                        max_percent: false
                    },
                    limit: {
                        amount: '',
                        time: ''
                    }
                },
                time_before_start_enabled: 0,
                days_before_start: 0,
                hours_before_start: 0,
                minutes_before_start: 0,
                update_data: ['line', 'home', 'away', 'over', 'under', 'stake'],
                update_events: ['line', 'home', 'away', 'over', 'under', 'stake'],
            },
            selectedTeamObjects: [],
            selectedLeagueObjects: [],
            diffModeOptions: [
                {
                    id: 'diff',
                    value: this.$t('min_max_diff')
                },
                {
                    id: 'sdiff',
                    value: this.$t('changes_sum')
                },
            ],
            statusOptions: [
                {
                    id: 0,
                    value: this.$t('disabled')
                },
                {
                    id: 1,
                    value: this.$t('enabled')
                },
                {
                    id: 2,
                    value: this.$t('updates_only')
                }
            ],
            updateOptions: [
                {
                    id: 'line',
                    value: this.$t('line')
                },
                {
                    id: 'home',
                    value: this.$t('home')
                },
                {
                    id: 'away',
                    value: this.$t('away')
                },
                {
                    id: 'over',
                    value: this.$t('over')
                },
                {
                    id: 'under',
                    value: this.$t('under')
                },
                {
                    id: 'stake',
                    value: this.$t('stake')
                },
            ],
            sendUpdateOptions: [
                {
                    id: 0,
                    value: this.$t('1st_odds')
                },
                {
                    id: 1,
                    value: this.$t('all')
                },
                {
                    id: 2,
                    value: this.$t('custom')
                }
            ],
            updateTimeOptions: [
                {
                    id: 0,
                    value: this.$t('last')
                },
                {
                    id: 1,
                    value: this.$t('1_minute')
                },
                {
                    id: 5,
                    value: this.$t('5_minutes')
                },
                {
                    id: 10,
                    value: this.$t('10_minutes')
                },
                {
                    id: 15,
                    value: this.$t('15_minutes')
                },
                {
                    id: 30,
                    value: this.$t('30_minutes')
                },
                {
                    id: 60,
                    value: this.$t('1_hour')
                },
                {
                    id: 1440,
                    value: this.$t('24_hours')
                }
            ],
            marketOptions: [
                {
                    id: '0',
                    value: this.$t('select_market')
                },
                {
                    id: 'wdw',
                    value: this.$t('wdw')
                },
                {
                    id: 'asian_handicap',
                    value: this.$t('asian_handicap')
                },
                {
                    id: 'over_under',
                    value: this.$t('over_under')
                }
            ],
            subMarketOptions: [
                {
                    id: '0',
                    value: this.$t('select_submarket')
                },
            ],
            subMarketRealOptions: {
                wdw: [
                    {
                        id: '0',
                        value: this.$t('select_submarket')
                    },
                    {
                        id: 'home',
                        value: this.$t('home')
                    },
                    {
                        id: 'draw',
                        value: this.$t('draw')
                    },
                    {
                        id: 'away',
                        value: this.$t('away')
                    },
                ],
                asian: [
                    {
                        id: '0',
                        value: this.$t('select_submarket')
                    },
                    {
                        id: 'home',
                        value: this.$t('home')
                    },
                    {
                        id: 'away',
                        value: this.$t('away')
                    },
                ],
                total: [
                    {
                        id: '0',
                        value: this.$t('select_submarket')
                    },
                    {
                        id: 'over',
                        value: this.$t('over')
                    },
                    {
                        id: 'under',
                        value: this.$t('under')
                    }
                ],
            },
            sportOptions: [
                {
                    id: 'all',
                    value: this.$t('all_sports')
                },
                {
                    id: 'football',
                    value: this.$t('football')
                },
                {
                    id: 'tennis',
                    value: this.$t('tennis')
                },
                {
                    id: 'basketball',
                    value: this.$t('basketball')
                }
            ],
            timeBeforeStartOptions: [
                {
                    id: '0',
                    value: this.$t('unlimited')
                },
                {
                    id: '1',
                    value: this.$t('custom')
                },
            ]
        }
    },
    created(){
        if (this.selectedUrl){
            this.preloader = true;
        }
    },
    methods: {
        afterSuccessFromGetEditData(res) {
            var tempData = res.data;
            tempData.market = 0;
            tempData.subMarket = 0;
            //tempData.diff_mode = 'diff';
            tempData.update = {
                time: 0,
                odds: {
                    min: '',
                    max: '',
                    min_percent: false,
                    max_percent: false
                },
                stake: {
                    min: '',
                    max: '',
                    min_percent: false,
                    max_percent: false
                },
                limit: {
                    amount: '',
                    time: ''
                }
            };
            tempData.update_data = JSON.parse(tempData.update_data);
            tempData.update_events = JSON.parse(tempData.update_events);
            var selectedTeamObjects = tempData.teams.map(function(team) {
                return {'id': team.team_id, 'name': team.parent.name};
            });
            var selectedLeagueObjects = tempData.leagues.map(function(league) {
                return {'id': league.league_id, 'name': league.parent.name};
            });
            tempData.teams = selectedTeamObjects;
            tempData.leagues = selectedLeagueObjects;
            tempData.conditions.forEach((condition) => {
                if (condition.condition == 'market'){
                    tempData.market = String(condition.value);
                } else if (condition.condition == 'sub_market'){
                    tempData.subMarket = String(condition.value);
                } else if (condition.condition == 'min_odds'){
                    tempData.min_odds = condition.value;
                } else if (condition.condition == 'max_odds'){
                    tempData.max_odds = condition.value;
                } else if (condition.condition == 'min_stake'){
                    tempData.min_stake = condition.value;
                } else if (condition.condition == 'max_stake'){
                    tempData.max_stake = condition.value;
                } else if (condition.condition == 'odds_change_min'){
                    tempData.update.odds.min = condition.value;
                    tempData.update.odds.min_percent = condition.percent;
                } else if (condition.condition == 'odds_change_max'){
                    tempData.update.odds.max = condition.value;
                    tempData.update.odds.max_percent = condition.percent;
                } else if (condition.condition == 'stake_change_min'){
                    tempData.update.stake.min = condition.value;
                    tempData.update.stake.min_percent = condition.percent;
                } else if (condition.condition == 'stake_change_max'){
                    tempData.update.stake.max = condition.value;
                    tempData.update.stake.max_percent = condition.percent;
                } else if (condition.condition == 'time_change'){
                    tempData.update.time = condition.value;
                } else if (condition.condition == 'limit_time'){
                    tempData.update.limit.time = condition.value;
                } else if (condition.condition == 'limit_amount'){
                    tempData.update.limit.amount = condition.value;
                }
            });
            if (tempData.time_before_kickoff > 0){
                var days = Math.floor(tempData.time_before_kickoff / 1440);
                var hours = Math.floor((tempData.time_before_kickoff - (days * 1440)) / 60);
                var minutes = tempData.time_before_kickoff - (days * 1440) - (hours * 60);

                tempData.time_before_start_enabled = '1';
                tempData.days_before_start = days;
                tempData.hours_before_start = hours;
                tempData.minutes_before_start = minutes;
            } else {
                tempData.time_before_start_enabled = '0';
                tempData.days_before_start = 0;
                tempData.hours_before_start = 0;
                tempData.minutes_before_start = 0;
            }
            tempData.conditions = null;
            this.formData = tempData;
            this.marketChange(false);
            this.preloader = false;
        },
        beforeSubmit() {
            this.preloader = true;
        },
        submit() {
            if (this.selectedId){
                this.formData.id = this.selectedId;
            }
            this.save(this.formData);
        },
        afterSuccess(res) {
            this.preloader = false;
            this.hideModal();
            if (this.selectedId){
                this.$toastr.s(this.$t('notification_updated'));
            } else {
                this.$toastr.s(this.$t('notification_created'));
            }
            this.$emit('afterSubmitDone');
        },
        afterError(){
            this.preloader = false;
            this.closeModal();
        },
        marketChange(reset){
            if (this.formData.market == 'wdw'){
                this.subMarketOptions = this.subMarketRealOptions.wdw;
            } else if (this.formData.market == 'asian_handicap'){
                this.subMarketOptions = this.subMarketRealOptions.asian;
            } else if (this.formData.market == 'over_under'){
                this.subMarketOptions = this.subMarketRealOptions.total;
            } else {
                this.subMarketOptions = [{
                    id: '0',
                    value: this.$t('select_submarket')
                }];
            }
            if (reset){
                this.formData.subMarket = 0;
            }
        },
        hideModal() {
            $('#' + this.modalId).modal('hide');
        },
        closeModal() {
            this.hideModal();
            this.$emit('close-modal')
        }
    }
}
</script>
